<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-md-10 col-12">
                  <CIcon name="cil-grid" />Pensiones
                </div>
                <div class="col-md-2 col-12">
                  <!-- Gestión -->
                  <div class="form-group">
                    <label class="control-label" for="courses_offered_year"
                      >Gestión:</label
                    >
                    <b-form-select
                      v-model="columnFilter.courses_offered_year"
                      :options="coursesOfferedYearsOptions"
                      id="courses_offered_year"
                      size="sm"
                      @change="filterTable"
                    >
                    </b-form-select>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen cursos programados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>
              <template #courses_offered_period="{ item }">
                <td>
                  Gestión: {{ item.courses_offered_year }} Periodo:
                  {{ item.courses_offered_period | period }}
                </td>
              </template>

              <template #syllabus_tuition_price="{ item }">
                <td class="text-right">
                  {{ item.syllabus_tuition_price | currency }}
                </td>
              </template>
              <template #schedule="{ item }">
                <td class="text-right">
                  <span style="white-space: pre">{{
                    item | time_courses_offered
                  }}</span>
                </td>
              </template>
              <template #sale_total_fines="{ item }">
                <td class="text-right">
                  <span v-if="item.sale_total_fines !== null">
                    {{ item.sale_total_fines | currency }}
                  </span>
                  <span v-else> - </span>
                </td>
              </template>
              <template #sale_total_paid="{ item }">
                <td class="text-right">
                  <span v-if="item.sale_total_paid !== null">
                    {{ item.sale_total_paid | currency }}
                  </span>
                  <span v-else> - </span>
                </td>
              </template>
              <template #sale_id="{ item }">
                <td style="text-align: center">
                  <div v-if="item.tuition_price > 0">
                    <span
                      class="badge bg-danger"
                      v-if="item.sale_id == 0 && item.tuition_price > 0"
                      >No pagada</span
                    >
                    <span class="badge bg-success" v-else>Pagada</span>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Registrations from "@/plugins/services/registrations";
import Students from "@/plugins/services/students";
// components

export default {
  name: "RegistrationsWithTuitionsList",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
        },
        {
          key: "course_name",
          label: "Curso",
          filter: false,
        },
        {
          key: "courses_offered_period",
          label: "Periodo",
          filter: false,
        },
        {
          key: "syllabus_description",
          label: "Pensum",
          filter: false,
        },
        {
          key: "courses_offered_type_of_course",
          label: "Tipo de curso",
          filter: false,
        },
        {
          key: "schedule",
          label: "Horario",
          filter: false,
        },
        {
          key: "syllabus_tuition_name",
          label: "Pensión",
          filter: false,
        },
        {
          key: "syllabus_tuition_price",
          label: "Precio pensión",
          filter: false,
        },
        {
          key: "sale_total_fines",
          label: "Multas pagadas",
          filter: false,
        },
        {
          key: "sale_total_paid",
          label: "Total pagado",
          filter: false,
        },
        {
          key: "sale_id",
          label: "Estado",
          sorter: false,
          filter: false,
        },
      ],
      student: {
        id: 0,
      },
      items: [],
      columnFilter: {
        asc: false,
        enabled: true,
      },
      enabledOptions: Constants.enabledOptions,
      coursesOfferedYearsOptions: [],
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    this.columnFilter.student_person_id = this.userAuth.id;
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("registration-with-tuitions-list", q);
      Registrations.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        student_id: this.student_id,
        asc: false,
        enabled: true,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
  },
};
</script>
